// src/Constants/Version.js
import versionData from '../version.json'
export const SOFTWARE_VERSION = versionData.version;
